export default __webpack_public_path__ + "static/media/Vector.122ca24b.svg";